var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVoucher(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Voucher",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_24724",
    "data-name": "Rechteck 24724",
    width: 40,
    height: 40,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_19356",
    "data-name": "Gruppe 19356",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_284144",
    "data-name": "Pfad 284144",
    d: "M20.735,38.75a1.779,1.779,0,0,1-1.305-.571l-3.3-3.572a.288.288,0,0,0-.259-.084l-4.767.952A1.778,1.778,0,0,1,8.993,33.94l-.568-4.828a.278.278,0,0,0-.159-.219L3.85,26.859a1.776,1.776,0,0,1-.808-2.483l2.378-4.24a.278.278,0,0,0,0-.271L3.042,15.624a1.776,1.776,0,0,1,.808-2.483l4.416-2.033a.278.278,0,0,0,.159-.219l.568-4.828a1.778,1.778,0,0,1,2.113-1.535l4.767.951a.282.282,0,0,0,.259-.084l3.3-3.571a1.837,1.837,0,0,1,2.61,0l3.3,3.572a.273.273,0,0,0,.259.083l4.767-.951a1.778,1.778,0,0,1,2.113,1.535l.568,4.828a.278.278,0,0,0,.159.219l4.416,2.034a1.773,1.773,0,0,1,.806,2.483l-2.376,4.24a.274.274,0,0,0,0,.27l2.378,4.241a1.775,1.775,0,0,1-.807,2.483L33.2,28.893a.278.278,0,0,0-.159.219l-.568,4.828a1.778,1.778,0,0,1-2.113,1.535L25.6,34.523a.281.281,0,0,0-.259.085l-3.3,3.571a1.779,1.779,0,0,1-1.305.571m-4.812-5.731a1.8,1.8,0,0,1,1.311.57l3.3,3.573a.238.238,0,0,0,.408,0l3.3-3.572a1.775,1.775,0,0,1,1.654-.538L30.657,34a.273.273,0,0,0,.217-.048.268.268,0,0,0,.112-.192l.569-4.828a1.788,1.788,0,0,1,1.022-1.406L36.993,25.5a.275.275,0,0,0,.148-.166.279.279,0,0,0-.022-.22L34.741,20.87a1.787,1.787,0,0,1,0-1.74l2.376-4.239a.278.278,0,0,0,.023-.221.275.275,0,0,0-.148-.166l-4.416-2.033a1.788,1.788,0,0,1-1.022-1.406l-.569-4.828a.268.268,0,0,0-.112-.192A.275.275,0,0,0,30.657,6l-4.767.951a1.773,1.773,0,0,1-1.654-.536l-3.3-3.573a.238.238,0,0,0-.408,0l-3.3,3.572a1.783,1.783,0,0,1-1.654.537L10.813,6a.271.271,0,0,0-.217.048.268.268,0,0,0-.112.192l-.569,4.828a1.788,1.788,0,0,1-1.022,1.406L4.477,14.5a.276.276,0,0,0-.126.387l2.378,4.24a1.793,1.793,0,0,1,0,1.739L4.351,25.11a.276.276,0,0,0,.126.387L8.893,27.53a1.788,1.788,0,0,1,1.022,1.406l.569,4.828a.268.268,0,0,0,.112.192.273.273,0,0,0,.217.048l4.767-.951a1.734,1.734,0,0,1,.343-.034",
    fill: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_284145",
    "data-name": "Pfad 284145",
    d: "M15.5,26.25a.75.75,0,0,1-.53-1.28l10.5-10.5a.75.75,0,0,1,1.06,1.06l-10.5,10.5a.744.744,0,0,1-.53.22",
    fill: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_284146",
    "data-name": "Pfad 284146",
    d: "M15.5,19.75a3.25,3.25,0,1,1,3.25-3.25,3.254,3.254,0,0,1-3.25,3.25m0-5a1.75,1.75,0,1,0,1.75,1.75,1.752,1.752,0,0,0-1.75-1.75",
    fill: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_284147",
    "data-name": "Pfad 284147",
    d: "M25.5,27.75a3.25,3.25,0,1,1,3.25-3.25,3.254,3.254,0,0,1-3.25,3.25m0-5a1.75,1.75,0,1,0,1.75,1.75,1.752,1.752,0,0,0-1.75-1.75",
    fill: "#1d1d1b"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVoucher);
export default __webpack_public_path__ + "static/media/voucher.5c50502e7f53cb68cfdcd665f4f68790.svg";
export { ForwardRef as ReactComponent };